import { HCF, HValid as MHValid } from "@macashipo/mlib"

const HValid = {
  validAllRulesOfValue: MHValid.validAllRulesOfValue,
  checkValidField: (field, value) => {
    let _validations = HCF.getCF("Validations")
    console.log("checkValidField", field, value, _validations)
    if (
      field &&
      _validations &&
      _validations[field] &&
      Array.isArray(_validations[field])
    ) {
      for (let r of _validations[field]) {
        let _rs = HValid.checkOneValid(r, value)
        if (_rs !== true) {
          return _rs
        }
      }
    }
    return true
  },
  checkOneValid: (obj, value) => {
    if (obj) {
      let _pattern = obj.Pattern
      let _validType = obj.ValidType
      let _message = obj.Message
      if (value === null || value === "") {
        //nếu empty thì coi như valid, check required riêng
        return true
      }
      if (_validType == "Regex") {
        let _rg = new RegExp(_pattern)
        console.log("checkOneValid", obj, _rg, value)
        if (_rg.test(value)) {
          return true
        } else {
          return _message
        }
      }
    }
    return true
  },
  checkValidForms: (listCheckValid, values) => {
    let _valid = true
    let _rsValid = {}
    if (listCheckValid && values) {
      let _fields = Object.keys(listCheckValid)
      for (let f of _fields) {
        let frules = listCheckValid[f]
        if (frules.fgCheckValid) {
          console.log("checkValidForms:", f, frules)
          let _rs = HValid.checkValidField(frules.fgCheckValid, values[f])
          if (_rs !== true) {
            _valid = false
            _rsValid[f] = _rs
          }
        }
      }
    }
    if (_valid === false) {
      return _rsValid
    }
    return _valid
  },
}

export default HValid
